import React from "react";
import { Modal } from "native-base";

export const ModalCloseButtonWrapper = ({ onClick }) => {
  return <Modal.CloseButton onPress={onClick} />;
};
